import React from "react";
import { useAudioSystem } from "../context/AudioContext";
import { Music, Radio, VolumeX, Square } from "lucide-react";

export default function StatusBar() {
  const { status, priorityNow, musicTrack, muted } = useAudioSystem();

  let cfg;
  if (status === "priority") {
    cfg = {
      cls: "bg-[#FF3B30] text-white animate-emergency",
      icon: <Radio className="w-10 h-10" />,
      title: "PRIORITY AUDIO ACTIVE",
      sub: priorityNow ? `${priorityNow.name} · Playing…` : "Playing…",
    };
  } else if (muted || status === "muted") {
    cfg = {
      cls: "bg-[#FFCC00]/20 text-[#FFCC00] border border-[#FFCC00]/50",
      icon: <VolumeX className="w-10 h-10" />,
      title: "SYSTEM MUTED",
      sub: "All audio silenced",
    };
  } else if (status === "music") {
    cfg = {
      cls: "bg-[#FF007F]/15 text-[#FF007F] border border-[#FF007F]/50",
      icon: <Music className="w-10 h-10" />,
      title: "MUSIC PLAYING",
      sub: musicTrack ? `Spotify · ${musicTrack.name}` : "Spotify",
    };
  } else {
    cfg = {
      cls: "bg-white/5 text-[#A1A1AA] border border-white/10",
      icon: <Square className="w-10 h-10" />,
      title: "MUSIC STOPPED",
      sub: "System silent — ready",
    };
  }

  return (
    <div data-testid="status-bar" className={`rounded-2xl px-6 py-4 flex items-center gap-5 ${cfg.cls}`}>
      <div className="shrink-0">{cfg.icon}</div>
      <div className="min-w-0">
        <div data-testid="status-title" className="font-display font-black text-3xl md:text-4xl tracking-tight leading-none">{cfg.title}</div>
        <div className="font-semibold text-base md:text-lg opacity-90 truncate mt-1">{cfg.sub}</div>
      </div>
    </div>
  );
}
